export default class FinanceSummary {
    static create(finance) {        
        if (finance.result) {
            const summary = {
                financeType: finance.currentParams?.financeTypeCode,
                calculationDate: finance.result?.calculationDate,
                productName: finance.result?.productName,
                campaignCode: finance.currentParams?.campaignCode,
                monthlyPayments: Number(finance.result?.payments?.regularPayment?.grossValue),
                apr: Number(finance.result?.rates?.effectiveRate?.percentage),
                interestFixed: Number(finance.result?.rates?.nominalRate?.percentage),
                term: Number(finance.result?.term?.term),
                mileage: Number(finance?.result?.expectedUsage?.value),
                customerContribution: Number(finance.deposit),
                financeContribution: Number(finance.getFinanceContribution()),
                dealerContribution: 0,
                totalDeposit: Number(finance.result?.payments?.deposit?.grossValue),
                totalCredit: Number(finance.result?.amountFinanced?.grossValue),
                totalChargeForCredit: Number(finance.result?.totalInterestPayable),
                totalPayable: Number(finance.result?.totalPayable?.grossValue),
                assetPrice: Number(finance.result?.cost?.grossValue),
            };

            const optionalFinalPayment = finance.result?.payments?.finalPayment?.grossValue;
            if (optionalFinalPayment !== null && optionalFinalPayment !== undefined) { summary.optionalFinalPayment = Number(optionalFinalPayment); }

            const optionToPurchase = finance.getOTP();
            if (optionToPurchase !== null && optionToPurchase !== undefined) { 
                summary.optionToPurchase = Number(optionToPurchase); 
                summary.totalChargeForCredit += summary.optionToPurchase;}

            const excessMileage = finance.getExcessMileage();
            if (excessMileage !== null && excessMileage !== undefined) { summary.excessMileage = Number(excessMileage); }

            return summary;
        }
    }
}
